import { getSearch } from 'connected-react-router';

export const getRef = state => {
  return new URLSearchParams(getSearch(state)).get('ref');
};
export const getAfterRegister = state => {
  return new URLSearchParams(getSearch(state)).get('after_register');
};
